let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jKxVf")).then(() => parcelRequire('arEu0'));